/** Settings stored inside statistics.data JSONB */
export type StatisticDataSettings = {
  showDetailedAnalysis?: boolean;
};

/** Default true — section hidden only when explicitly set to false */
export function isDetailedAnalysisVisible(
  data?: StatisticDataSettings | null
): boolean {
  return data?.showDetailedAnalysis !== false;
}
